export const FieldType = Object.freeze({
    NotAKey:0,
    Text: 1,
    Query:2
  });